import Component from '../classes/Component';

export default class BuildVideos extends Component {
	constructor() {
		super({
			element: '.c-container--billboard-video',
			elements: {
				button: '[data-play-video]',
				progress: '.c-billboard__progress',
				indicators: '.c-billboard__indicator',
				indicatorGroups: '.c-billboard__indicators',
				toggles: '[name="build"]',
				videos: '[data-video]',
				summary: 'summary',
				mobileButtons: '[data-mobile-play]',
				mobileVideo: '[data-mobile-video]',
				timestamps: '[data-video-timestamp]',
			},
		});

		this.timeStamps = [0.1, 23, 52, 78, 98, 0.1, 52, 87, 0.1, 32, 84, 101];
		this.stateStartIndices = this.timeStamps.map((e, i) => (e === 0 ? i : '')).filter(String);

		const checkedToggle = [...this.elements.toggles].filter(toggle => toggle.checked)[0];
		const checkedIndex = [...this.elements.toggles].indexOf(checkedToggle);

		this.activeVideo = null;
		this.selectedState = checkedToggle.id;
		this.videoDuration = 0;
		this.autoplayIndex = 0;
		this.playing = false;
		this.setState(this.selectedState, checkedIndex);
		this.listenForClick();
		this.listenForUpdate();
	}

	setVideo() {
		const { videos } = this.elements;
		videos.forEach(video => {
			video.pause();
			video.classList.remove('active');
			if (video.dataset.video === this.selectedState) {
				this.activeVideo = video;
			}
		});
		this.activeVideo.classList.add('active');
		this.videoDuration = this.activeVideo.duration;
		this.activeVideo.load();
	}

	setState(state, index) {
		const { indicatorGroups } = this.elements;
		this.selectedState = state;
		indicatorGroups.forEach(group => {
			group.classList.remove('active');
		});
		indicatorGroups[index].classList.add('active');
		indicatorGroups[index].querySelector('.c-billboard__indicator').classList.add('active');
		this.setVideo();
		this.listenForUpdate();
	}

	playVideo() {
		this.elements.button.classList.add('playing');
		this.element.classList.add('playing');
		this.activeVideo.play();
		this.activeVideo.play();
		this.activeVideo.play();
		this.playing = true;
	}

	resetVideos() {
		const { videos } = this.elements;

		videos.forEach(video => {
			video.pause();
			video.classList.remove('active');
			video.controls = false;
		});
	}

	playVideobyId(id, time) {
		const { videos } = this.elements;
		videos.forEach(video => {
			video.pause();
			video.classList.remove('active');
			video.controls = false;
			if (video.dataset.video === id) {
				this.activeVideo = video;
			}
		});

		if (time) {
			this.activeVideo.currentTime = time;
		}

		this.activeVideo.play();
		this.activeVideo.controls = true;
		this.activeVideo.classList.add('active');
	}

	pauseVideo() {
		this.elements.button.classList.remove('playing');
		this.element.classList.remove('playing');
		this.activeVideo.pause();
		this.playing = false;
	}

	updateProgress(value) {
		this.element.setAttribute('style', `--progress: ${value / this.videoDuration};`);
	}

	focusIndicator(indicator) {
		this.elements.indicators.forEach(element => {
			element.classList.remove('active');
			element.style.setProperty('--indicator-progress', 0);
		});
		indicator.classList.add('active');
		// indicator.scrollIntoView({ inline: 'start', block: 'end' });
	}

	// eslint-disable-next-line class-methods-use-this
	setIndicatorProgress(indicator, progress) {
		indicator.style.setProperty('--indicator-progress', progress);
	}

	get activeIndicatorIndex() {
		const activeIndicator = document.querySelector('.c-billboard__indicators.active .c-billboard__indicator.active');
		const activeIndex = [...this.elements.indicators].indexOf(activeIndicator);
		return activeIndex;
	}

	autoplay(time) {
		const isLastChild = this.elements.indicators[this.activeIndicatorIndex].nextElementSibling === null;

		const nextTime = isLastChild ? this.videoDuration : this.timeStamps[this.autoplayIndex];
		// check if active indicator is last child
		// calculate the percentage duration between the current and next time stamp
		const currentIndicatorProgress = (time - this.timeStamps[this.autoplayIndex - 1]) / (nextTime - this.timeStamps[this.autoplayIndex - 1]) || 0;
		this.setIndicatorProgress(this.elements.indicators[this.activeIndicatorIndex], currentIndicatorProgress);

		if (time >= nextTime) {
			this.focusIndicator(this.elements.indicators[this.autoplayIndex]);
			this.autoplayIndex += 1;
		}
	}

	listenForClick() {
		const {
			button, indicators, toggles, videos, mobileButtons, timestamps, summary,
		} = this.elements;
		button.addEventListener('click', () => {
			if (!this.playing) {
				this.playVideo();
			} else {
				this.pauseVideo();
			}
		});
		indicators.forEach((indicator, index) => {
			indicator.addEventListener('click', () => {
				this.focusIndicator(indicator);
				this.autoplayIndex = index + 1;
				const selectedTime = this.timeStamps[index];
				this.activeVideo.currentTime = selectedTime;
				this.playVideo();
			});
		});
		toggles.forEach((toggle, index) => {
			toggle.addEventListener('click', () => {
				this.setState(toggle.id, index);
				// const stateStampStart = this.stateStartIndices[index];
				this.autoplayIndex = this.activeIndicatorIndex;
				this.pauseVideo();
				this.updateProgress(0);
			});
		});
		videos.forEach(video => {
			video.addEventListener('click', () => {
				if (!this.playing) {
					this.playVideo();
				} else {
					this.pauseVideo();
				}
			});
		});

		summary.forEach(el => {
			el.addEventListener('click', () => {
				this.resetVideos();

				setTimeout(() => {
					window.dispatchEvent(new Event('resize'));
				}, 0);
			});
		});

		mobileButtons.forEach(buttonEl => {
			buttonEl.addEventListener('click', () => {
				const videoID = buttonEl.dataset.mobilePlay;
				this.playVideobyId(videoID);
			});
		});

		timestamps.forEach((timestamp, index) => {
			timestamp.addEventListener('click', () => {
				this.autoplayIndex = index + 1;
				const selectedTime = this.timeStamps[index];
				const id = timestamp.dataset.videoTimestamp;

				this.playVideobyId(id, selectedTime);
			});
		});
	}

	listenForUpdate() {
		this.activeVideo.addEventListener('timeupdate', () => {
			if (this.playing) {
				this.updateProgress(this.activeVideo.currentTime);
				this.autoplay(this.activeVideo.currentTime);
			}
		});
	}
}
